import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import Button from 'components/Button'
import { ConfirmUserTransactionViewModel } from '../../ConfirmUserTransactionViewModel'
import { formatTransactionReason } from 'payouts/formatters/transaction-formatters'
import { Amount } from 'payouts/components/Amount'
import styles from './ConfirmNewTransactionModal.sass'

/**
 * Confirm Payout Modal
 */
export const ConfirmNewTransactionModal = observer(
  function ConfirmNewTransactionModal({
    vm,
  }: {
    vm: ConfirmUserTransactionViewModel
  }) {
    return (
      <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
        <ModalSheetHeader withCloseButton />
        <ModalSheetContent>
          <ModalSheetContentBlock>
            <ModalSheetContentIllustration
              src={require('assets/images/img_payment-methods.svg')}
            />
            <ModalSheetContentTitle>
              You are about to add a new transaction
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              Are you sure you want to add a{' '}
              <Emphasize>{formatTransactionReason(vm.reason)}</Emphasize> for{' '}
              <Emphasize>{vm.recipient.displayName}</Emphasize>, totalling{' '}
              <Emphasize>
                <Amount value={vm.amount} />
              </Emphasize>
              ?
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        </ModalSheetContent>

        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button onClick={vm.close}>Cancel</Button>
            <Button type="primary" onClick={vm.confirm}>
              Confirm Transaction
            </Button>
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </ModalSheet>
    )
  },
)

/**
 * Emphasize
 */
export function Emphasize({ children }: { children?: React.ReactNode }) {
  return <span className={styles.emphasize}>{children}</span>
}
